// extracted by mini-css-extract-plugin
export default {"productBanner":"ProductBanner_productBanner__Ku0tM"};